module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-div"
  }, [_c('div', {
    staticClass: "row main-card"
  }, [_c('div', {
    staticClass: "col-6 card-content"
  }, [_c('div', [_c('h2', [_vm._v("Page Not Found 🕵🏻‍♀️")]), _vm._v(" "), _c('p', [_vm._v("Oops! 😖 The requested URL was not found on this server.")])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "error",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to home")])]), _vm._v(" "), _c('div', {
    staticClass: "error-img"
  }, [_c('img', {
    attrs: {
      "src": "/assets/error-page-img.png",
      "alt": "error"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card-img"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/assets/loginlogoblue.png",
      "width": "11%",
      "height": "11%",
      "alt": "logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c982b60","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/errorPage/error.vue
// module id = 2609
// module chunks = 0